export default "__VITE_ASSET__DNbKQUst__"